import React from 'react'

function TenderTextDSRADN() {
  return (
    <embed src="\pdfs\EAT1.6.4.2_DS-RA-DN80_Step_twist_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextDSRADN